import { defineAbility } from '@casl/ability'

const ability = defineAbility((allow) => {
  allow('test', 'Line');
});

export { ability, defineAbility };


